export const getRecurrenceText = (item) => {
    if (item?.price?.recurring?.interval === 'free') return ''
    const type =  item?.price?.recurring?.interval === 'month' ? 'monthly' : 'annually'
    return `paid ${type}`
}
